import { render, staticRenderFns } from "./TopClientes.vue?vue&type=template&id=6486d9ec"
import script from "./TopClientes.vue?vue&type=script&lang=js"
export * from "./TopClientes.vue?vue&type=script&lang=js"
import style0 from "./TopClientes.vue?vue&type=style&index=0&id=6486d9ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports